import { ClientPortfolioPaymentFrequencyEnum } from "web_myplann/Infrastructure/Api/Api";
import type { LoansFormInput } from "web_myplann/Portfolio/Forms/LoansForm/loansFormSchema";

export const LOANS_FORM_DEFAULT_VALUES: LoansFormInput = {
	name: "",
	contractNumber: "",
	producer: "",
	product: "",
	productCategoryId: null,
	signedAt: null,
	startAt: null,
	endAt: null,
	value: null,
	coDebtors: [],
	change: {
		originalObligationAmount: null,
		installment: null,
		interestRate: null,
		fixationEndDate: null,
		paymentFrequency: ClientPortfolioPaymentFrequencyEnum.Monthly,
	},
};
